import { render, staticRenderFns } from "./psuBmfAffirmIndex.vue?vue&type=template&id=52b4b6f4"
import script from "./psuBmfAffirmIndex.vue?vue&type=script&lang=js"
export * from "./psuBmfAffirmIndex.vue?vue&type=script&lang=js"
import style0 from "./psuBmfAffirmIndex.vue?vue&type=style&index=0&id=52b4b6f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports